import { useEffect, useRef, useState } from "react";
import { Button } from "../../../../components/ui/Button";
import { ProgressSpinner } from "primereact/progressspinner";
import { isEmpty } from "lodash";
import { useGetCampaigns } from "../../../../queries/campaigns";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';

function CampaignsList({ short = false, setShowOptions, onSelect }) {
    const { t } = useTranslation();
    const [searchTerm, setSearchTerm] = useState("");
    const { selectedCampaign } = useSelector((state) => state.device);

    const {
        data,
        isLoading,
        isFetchingNextPage,
        fetchNextPage,
        hasNextPage
    } = useGetCampaigns({
        per_page: 10,
        search: searchTerm.trim() || undefined
    });

    const observerRef = useRef(null);

    // Infinite scroll observer
    useEffect(() => {
        if (!observerRef.current || !hasNextPage) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    fetchNextPage();
                }
            },
            { threshold: 1 }
        );

        observer.observe(observerRef.current);

        return () => observer.disconnect();
    }, [observerRef.current, hasNextPage]);

    const handleInput = () => setSearchTerm(searchTerm.trim());
    const resetInput = () => setSearchTerm("");
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleInput();
        }
    };

    // Flatten infinite data
    const campaigns = data?.pages.flatMap((page) => page.items) ?? [];

    return (
        <div
            className={`mt-2 w-full ${short ? "max-h-[150px" : "max-h-[300px"
                } ] overflow-hidden rounded-md border border-gray-200 bg-white shadow-lg`}
        >
            {/* Search Input */}
            <div className="relative flex w-full justify-start pb-2 pt-2 px-3 bg-gray-50 border-b">
                <input
                    type="text"
                    className="form-control h-[45px] w-8/12 md:w-10/12 hover:border-blue-500"
                    placeholder={t('common.search_placeholder')}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyDown={handleKeyPress}
                    disabled={isLoading}
                />
                {!isEmpty(searchTerm) && (
                    <Button
                        icon="pi pi-times"
                        rounded
                        text
                        severity="primery"
                        aria-label={t('buttons.cancel')}
                        onClick={resetInput}
                        className="absolute inset-y-0 right-10 border-transparent bg-transparent text-black"
                    />
                )}
                <Button
                    icon="pi pi-search"
                    rounded
                    text
                    severity="primery"
                    aria-label={t('buttons.search')}
                    className="absolute inset-y-0 right-2 border-transparent bg-transparent text-black"
                    onClick={handleInput}
                    loading={isLoading}
                />
            </div>

            {/* Campaigns List */}
            <div
                className={`${short ? "h-[170px]" : "h-[250px]"
                    } flex flex-col overflow-y-auto`}
            >
                {isLoading ? (
                    <div className="flex justify-center items-center h-full">
                        <ProgressSpinner style={{ width: "50px", height: "50px" }} />
                    </div>
                ) : campaigns.length === 0 ? (
                    <h5 className="py-5 text-center w-full">
                        {isEmpty(searchTerm) ? "" : t('messages.no_results')}
                    </h5>
                ) : (
                    <div className={`${short ? "h-[170px]" : "h-[250px]"} d-flex flex-column scroll_container scroll_div  overflow-x-hidden  w-100`}>
                        <div className="d-flex flex-wrap mb-4">
                            {
                                campaigns?.map((item, index) => {

                                    return (
                                        <div className=" w-100 d-flex align-items-center justify-content-between   " ref={index === campaigns?.length - 1 ? observerRef : null} key={`${item.type} - ${index}`} >
                                            <div className={` font-[400px] col-9 col-md-3 col-sm-6 mx-1 fs-6 d-flex align-items-center w-100 cursor-pointer px-3  pt-[1rem] pb-[1.25rem]  border-r-2
                                                    ${item.id === selectedCampaign ? "pp-selected-row" : "hover:bg-[#e2e2e28a] hover:text-gray-600"}
                                                     `}
                                                onClick={() => {
                                                    // dispatch(setSelectedCampaign(item.id))
                                                    onSelect(item); // send selected campaign to parent
                                                    setShowOptions(false)
                                                }}> {item.name} </div>

                                        </div>
                                    )
                                })
                            }
                            {/* {
                                        isFetching && data?.length ?
                                            <ProgressSpinner
                                                className='h-[50px] w-[50px] flex justify-center items-center my-4'
                                                strokeWidth="3"
                                                fill="var(--surface-ground)"
                                                animationDuration="30s" /> : <></>
                                    } */}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default CampaignsList;
